<template>
  <v-sheet color="transparent">
    <v-toolbar>
      <v-toolbar-title>
        {{ $t('ITEM.ADD') }} {{ $t('APPS.ITEM') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn dark color="indigo" @click="$router.go(-1)">
        {{ $t('BUTTON.BACK') }}
      </v-btn>
      <v-btn
        class="text-none font-weight-light ml-2"
        @click="playMode(!playing)"
      >
        {{ playing ? this.$t('APPS.EXIT_PLAY_MODE') : this.$t('APPS.PLAY_MODE') }}
      </v-btn>
    </v-toolbar>

    <v-card id="general" class="mt-3" outlined :disabled="playing">
      <v-card-title class="pb-0">
        <v-icon left v-text="'mdi-cellphone-text'" />
        {{ $t('APPS.GENERAL_DATA') }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <alert-error class="mt-4" :error="errors" />
        <app-general-form
          v-model="generalData"
          @generalDataStatus="generalDataReady = $event"
        />
      </v-card-text>
    </v-card>

    <v-card
      id="layout"
      class="mt-3"
      outlined
      :disabled="!playing && !generalDataReady"
    >
      <v-card-title class="pb-0">
        <v-icon left v-text="'mdi-page-layout-header-footer'" />
        {{ $t('APPS.LAYOUT_DATA') }}
      </v-card-title>
      <v-card-text>
        <app-layout-form v-model="layoutData">
          <template v-slot:buttons="{ valid }">
            <v-btn
              color="primary"
              class="mt-4 elevation-4"
              :disabled="!valid || !generalDataReady || playing"
              @click.prevent="storeGeneralData"
            >

                {{ $t('APPS.CREATE') }}

            </v-btn>
            <v-btn
              v-if="playing"
              class="text-none font-weight-light ml-2 mt-4"
              @click="playMode(!playing)"
            >
              {{ $t('APPS.EXIT_PLAY_MODE') }}
            </v-btn>
          </template>
        </app-layout-form>
      </v-card-text>
    </v-card>
  </v-sheet>
</template>

<script>
export default {
  name: 'AppsCreatePage',

  components: {
    AlertError: () => import('@/modules/_global/_components/AlertError'),
    AppGeneralForm: () =>
      import('@/modules/apps/components/AppGeneralForm.vue'),
    AppLayoutForm: () => import('@/modules/apps/components/AppLayoutForm.vue')
  },

  data: () => ({
    playing: false,
    generalDataReady: false,

    generalData: {},
    layoutData: {},

    errors: null
  }),

  methods: {
    storeGeneralData() {
      let formData = new FormData();

      Object.keys(this.generalData).forEach(key => {
        // TODO: if typeof this.data[key] == 'array' then JSON.stringify()
        formData.append(
          key,
          Array.isArray(this.generalData[key])
            ? JSON.stringify(this.generalData[key])
            : this.generalData[key]
        );
      });

      this.$store
        .dispatch('apps/storeApp', formData)
        .then(({ data }) => {
          this.storeLayoutData(data.id);
        })
        .catch(error => {
          this.errors = error.response;

          this.$vuetify.goTo('#general', {
            offset: 10
          });
        });
    },

    storeLayoutData(id) {
      this.$store
        .dispatch('apps/storeLayout', {
          id: id,
          layout: this.layoutData
        })
        .then(() => this.$router.push({ name: 'apps' }));
    },

    playMode(flag) {
      this.playing = flag;

      this.$vuetify.goTo(`#${flag ? 'layout' : 'general'}`, {
        offset: 10
      });
    }
  }
};
</script>
